import React from 'react';
import {IconButton, Typography, useTheme} from "@material-ui/core";
import IconHolder from "../../../../../../../components/IconHolder";
import {GroupiTheme} from "../../../../../../../customTheme";
import {makeStyles} from "@material-ui/core/styles";
import {styles} from "./styles";
import Edit from "../../../../../../../components/Icons/Edit";

const useStyles = makeStyles(styles);

const EditButton: React.FC<any> = ({setIsDisabled}) => {
  const classes = useStyles();
  const theme: GroupiTheme = useTheme();
  const handleClick = () => {
    setIsDisabled((prevState: any) => !prevState);
  };

  return (
    <div className={classes.button}>
      <IconButton
        color="primary"
        onClick={handleClick}>
        <IconHolder
          size={32}
          color={theme.palette.common.blue50}>
          <Edit/>
        </IconHolder>
      </IconButton>
      <Typography variant={'body2'}>
        Edit
      </Typography>
    </div>
  );
};

export default EditButton;
